import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { editComplaintFormData } from "services/prosecutorDecipilineService";
import { Complaints } from "types";
import { LoadingIcon } from "utils/constant";
import { COMPLIANT_STATUS } from "utils/constantValues";
import "../styles/AddEvidenceModal.css";

interface DecisionModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: Complaints;
  onRefresh: any;
}

export default function TerminateLitigationModal({
  isOpen,
  setIsOpen,
  complaintData,
  onRefresh,
}: DecisionModalProps) {
  // const canTerminateInspectionDailyHearing = useHasRole([
  //   ROLES.INSPECTION_PROSECUTOR,
  // ]);
  // const canTerminateCouncilDailyHearing = useHasRole([
  //   ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);

  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    files: [] as File[],
    termination_reason: "",
    order_given_by: "",
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!complaintData) return;

    setLoading(true);

    const data = new FormData();
    data.append("termination_document_file", formState?.files[0] || "");
    data.append("termination_reason", formState.termination_reason);
    data.append("order_given_by", formState.order_given_by);
    data.append("status", COMPLIANT_STATUS.TERMINATED);
    data.append("uu_id", String(complaintData?.uu_id));
    data.append(
      "accused_prosecutor_phone",
      complaintData?.accused_prosecutor_phone
    );
    data.append(
      "assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "user_id_assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_name",
      complaintData?.accused_prosecutor_name || ""
    );
    data.append(
      "user_id_accused_prosecutor_name",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_org_id",
      complaintData?.accused_prosecutor_org_id || ""
    );
    data.append(
      "accused_prosecutor_admin_unit_id",
      complaintData?.accused_prosecutor_admin_unit_id || ""
    );
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");

    const complaint_id = String(complaintData?.uu_id || "");
    const isFormData = true;

    try {
      await editComplaintFormData(data, complaint_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      setFormState({
        files: [] as File[],
        termination_reason: "",
        order_given_by: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Terminate Complaint"}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Order give by
            </label>
            <input
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              type="text"
              name="order_given_by"
              value={formState?.order_given_by}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Termination Reason
            </label>
            <textarea
              required
              rows={3}
              name="termination_reason"
              value={formState.termination_reason}
              onChange={handleChange}
              placeholder="Details here..."
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Termination File
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">Upload Files</p>
            {formState.files.length > 0 && (
              <div className="file-list">
                {formState.files.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-red-700 w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Terminate"
          )}
        </button>
      </form>
    </SideModal>
  );
}
